import { ShareEventMarket, Channel } from './constants';

const ShareEventName = 'QSShareToSocialMedia';
const ShareEventVersion = 1;

// 分享事件上报渠道枚举
const ShareEventChannel = {
    [Channel.FACEBOOK]: '1',
    [Channel.TWITTER]: '2',
    [Channel.TELEGRAM]: '3',
    [Channel.XIAOHONGSHU]: '4',
    [Channel.REDDIT]: '5',
    [Channel.INSTAGRAM]: '6',
    [Channel.SYSTEM]: '7'
};

// 分享事件上报eventEntity枚举
const EventEntityMap = {
    [ShareEventMarket.HK]: 'FUTU_HK',
    [ShareEventMarket.SG]: 'FUTU_SG',
    [ShareEventMarket.MY]: 'FUTU_MY',
    [ShareEventMarket.US]: 'FUTU_US',
    [ShareEventMarket.JP]: 'FUTU_JP',
    [ShareEventMarket.CA]: 'FUTU_CA',
    [ShareEventMarket.AU]: 'FUTU_AU'
};

// 分享事件上报
export function shareReport({ channel, material_id, string_id, user_home_market }) {
    if (!window.FEGOEditor) {
        const { ftReport } = window.FEGORender?.plugins;
        ftReport.ftReportIns.sdReport({
            eventName: ShareEventName,
            eventVersion: ShareEventVersion,
            eventEntity: EventEntityMap[user_home_market],
            payload: {
                channel_name: ShareEventChannel[channel],
                material_id,
                string_id,
                user_home_market
            }
        });
    }
}
